<template>
  <div class="page">
    <initio-panel @submit-handler="submitHandler" :errors="errors">
      <template v-slot:title>
        Get a quote
      </template>
      <template v-slot:sidebar>
       <initio-dont-insure />
      </template>
    </initio-panel>
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioDontInsure from '@/components/partials/DontInsure.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    InitioPanel,
    InitioDontInsure
  },
  mixins: [
    stepSubmit
  ],
  mounted () {
    this.$store.dispatch('getSchema', 'new/vehicle-confirm' )
      .then(response => {
        this.$store.commit('updateSchema', response);
      })
  },
  methods: {
    submitHandler() {
      let context = this;

      this.genericSubmitHandler()
        .then(response => {
          // console.log(response)

          // Get the data backend validation data for the conditional UW question
          if ( response.results.driver_inexperienced_petrol ) {
            this.$store.commit('updateBackendData', {
                'Vehicle.Confirm': {
                  driver_inexperienced_petrol: response.results.driver_inexperienced_petrol
                }
              }
            );
          } else {
            this.$store.commit('updateBackendData', {
                'Vehicle.Confirm': {
                  driver_inexperienced_petrol: false
                }
              }
            );
          }

        }, error => {
          // Don't actually need to log error here, as we show the errors on front-end ( else ends up in sentry )
          context.errors = error;
        });
    }
  },
  data () {
    return {
      errors: [],
      schema: [],
    }
  },
  computed: {
    ...mapGetters({
      currentSession: 'currentSession',
      answers: 'flattenedAnswers',
      client: 'client'
    }),
  },
  beforeMount () {
    // If start date not already set, default to today
    if ( !this.answers['Vehicle.Confirm'].vehicle_confirm_insurance_start ) {
      // TODO: fix this
      // set dynamic default value
      let d = new Date;
      this.$store.commit('setAnswer',{
        step: 'Vehicle.Confirm',
        answer: 'vehicle_confirm_insurance_start',
        value: ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear()
      });
    }

    // If a new client then default then default vehicle.confirm to 'new-driver' so its already expanded
    const is_new_client = ! this.client.cli_num;

    // If a existing client but no drivers, then default answer to 'new-driver'
    const existing_client_no_drivers = this.client && (!this.client.drivers || this.client.drivers.length === 0);

    // Don't pre-populate the answer if vehicle confirm driver already answered
    if( (is_new_client || existing_client_no_drivers) && ! this.answers['Vehicle.Confirm'].vehicle_confirm_driver  ){
      this.$store.commit('setAnswer',{
        step: 'Vehicle.Confirm',
        answer: 'vehicle_confirm_driver',
        value: 'new-driver'
      });
    }
  }
}

</script>

<style scoped lang="scss">
  
</style>